import { render, staticRenderFns } from "./actor_source.vue?vue&type=template&id=55a72f33&scoped=true"
import script from "./actor_source.vue?vue&type=script&lang=js"
export * from "./actor_source.vue?vue&type=script&lang=js"
import style0 from "./actor_source.vue?vue&type=style&index=0&id=55a72f33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a72f33",
  null
  
)

export default component.exports